module.exports = __webpack_public_path__ + "img/carrito.56c0cc5c.png";